import axiosInstance from '../common/axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;


const getSupplierWarehouse = async (id) => {
  const res = await axiosInstance.get(`${backendUrl}/api/warehouses/${id}`);
  return res.data;
}; 

const saveWarehouse = async (data) => {
  const res = await axiosInstance.post(`${backendUrl}/api/warehouses`, data);
  return res.data;
};

export const updateWarehouse = async (id, data) => {

  const res = await axiosInstance.put(`${backendUrl}/api/warehouses/${id}`, data);
  return res.data;
};

 export const fetchSupplierWarehouse = async () => {
   
     const res = await axiosInstance.get(`${backendUrl}/api/warehouses`);
  return res.data;
  };
 
 export const fetchSupplierBasicWarehouse = async () => {
   
     const res = await axiosInstance.get(`${backendUrl}/api/warehouses/basic`);
  return res.data;
  };

 export const checkWarehouseExists = async (name) => {
   
     const res = await axiosInstance.get(`${backendUrl}/api/warehouses/exists?name=${name}`);
  return res;
  };





 export const deleteSupplierWarehouse = async (id) => {
   const res = await axiosInstance.delete(`${backendUrl}/api/warehouses/${id}`);
  return res.data;
  }; 
 
const saveSupplierWarehouse = async (data) => {
  const res = await axiosInstance.post(`${backendUrl}/api/warehouses/supplier`, data);
  return res.data;
};

export default { getSupplierWarehouse, saveWarehouse, updateWarehouse , 
                fetchSupplierWarehouse, deleteSupplierWarehouse, 
                saveSupplierWarehouse,fetchSupplierBasicWarehouse,
                checkWarehouseExists};